<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import { getTraitName } from '../trait/translations';

  export let infusionId: number;

  $: src = `/images/infusions/${infusionId}20.webp`;
</script>

<img class="trait-image" {src} alt={getTraitName($LL, infusionId)} {...$$restProps} />
